module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNWJhOTg5OWQxZmRlNzYzYmM2YzNkYzAxNDk2YThjNzQucG5nIjs="